import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "src/redux/store";

// Use throughout your app instead of plain `useSelector`
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
